import React from 'react';
import { motion } from 'framer-motion';
import { Archway } from './graphics/Glyphs';
const stats = [{
  num: '8–10',
  label: 'Women',
  body: 'A small group, carefully curated.'
}, {
  num: '1',
  label: 'Shared villa',
  body: 'Beautiful. Intentional. Chosen with care.'
}, {
  num: '7',
  label: 'Days',
  body: 'Slow mornings. Long dinners. A new pulse.'
}];
export function House() {
  return <section id="how" className="bg-paper py-24 md:py-32 px-6 md:px-12 border-t border-ink/10" data-id="element-104">
      <div className="max-w-5xl mx-auto" data-id="element-105">
        <div className="text-center mb-16" data-id="element-106">
          <p className="eyebrow mb-6" data-id="element-107">The House</p>
          <motion.h2 initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="font-serif-display text-3xl md:text-5xl text-ink leading-[1.1]" data-id="element-108">
            One home. <span className="italic" data-id="element-109">A small world.</span>
          </motion.h2>
        </div>

        {/* Stats with connecting horizontal line on desktop, vertical on mobile */}
        <div className="relative grid md:grid-cols-3 gap-12 md:gap-8" data-id="element-110">
          {/* Mobile vertical line */}
          <motion.div initial={{
          scaleY: 0
        }} whileInView={{
          scaleY: 1
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 1.4
        }} style={{
          transformOrigin: 'top'
        }} className="md:hidden absolute left-1/2 -translate-x-px top-4 bottom-4 w-px bg-ink/15" data-id="element-111" />
          {/* Desktop horizontal line */}
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 1.4
        }} style={{
          transformOrigin: 'left'
        }} className="hidden md:block absolute left-[12%] right-[12%] top-12 h-px bg-ink/15" data-id="element-112" />

          {stats.map((s, i) => <motion.div key={s.label} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.7,
          delay: 0.3 + i * 0.15
        }} className="relative text-center bg-paper px-4" data-id="element-113">
              <span className="block w-2 h-2 rounded-full bg-sun mx-auto mb-6" data-id="element-114" />
              <p className="font-serif-display text-5xl md:text-6xl text-ink italic" data-id="element-115">
                {s.num}
              </p>
              <p className="eyebrow mt-3 mb-3 !text-ink" data-id="element-116">{s.label}</p>
              <p className="text-ink-soft text-[13px] leading-[1.7] max-w-[200px] mx-auto" data-id="element-117">
                {s.body}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-20 flex justify-center" data-id="element-118">
          <div className="w-20 md:w-24 text-ink/60" data-id="element-119">
            <Archway className="w-full h-auto" data-id="element-120" />
          </div>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="mt-10 text-center font-serif-display italic text-ink/60 text-lg md:text-2xl max-w-xl mx-auto leading-snug" data-id="element-121">
          You are not just visiting a place. <br data-id="element-122" />
          You are being invited into it.
        </motion.p>
      </div>
    </section>;
}